import React, { useState, useEffect } from "react";
// import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import API from "../../helper/AxiosInterceptor";

const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  const fetchUserDetails = async () => {
    try {
      await API.get(`${process.env.REACT_APP_API_URL}/merchants/user-profile`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setIsAuthenticated(true); // 🔥 NEW CHANGE
    } catch (error) {
      const errorMsg = error.response?.data?.message || "An error occurred";
      if (errorMsg.toString().toLowerCase() === "unauthorized" || error.response?.status === 401) {
        localStorage.removeItem("token");
        toast.error("Session expired");
        navigate("/login");
      }
      console.log("Error fetching :", errorMsg);
      setIsAuthenticated(false); // 🔥 NEW CHANGE
    }
  };

  useEffect(() => {
    fetchUserDetails(); // 🔥 NEW CHANGE
  }, []);

  if (isAuthenticated === null) {
    return null; // or loader
  }

  if (isAuthenticated === false) {
    return <Navigate to="/login" replace />;
  }



  return children;
};

export default PrivateRoute;

// import React from "react";
// import { Navigate } from "react-router-dom";

// const PrivateRoute = ({ children }) => {
//   const token = localStorage.getItem("token");

//   if (!token) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// };

// export default PrivateRoute;
